import {
  Directive,
  ElementRef,
  Renderer2,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: 'a'   // روی تمام تگ‌های <a> اعمال می‌شود
})
export class ExternalLinkDirective {

  private observer: MutationObserver | null = null;
  private readonly mainDomain = 'www.iraniexpert.com';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    // اجرای اولیه بعد از رندر Angular
    this.applyRelLogic();

    // ناظر برای تغییرات href و تغییرات HTML داخل CKEditor
    this.startObserver();
  }

  /**
   * بررسی اینکه لینک داخلیه یا خارجی و اعمال rel
   */
  private applyRelLogic() {
    const linkEl: HTMLAnchorElement = this.el.nativeElement;
    const href = linkEl.getAttribute('href');
  
    if (!href) return;
  
    const isInternal =
      href.startsWith('/') ||
      href.startsWith('#') ||
      !href.includes('://') ||
      href.includes(this.mainDomain);
  
    if (isInternal) {
      this.renderer.setAttribute(linkEl, 'rel', 'follow');
      this.renderer.removeAttribute(linkEl, 'target');
    } else {
      this.renderer.setAttribute(linkEl, 'rel', 'nofollow noopener');
      this.renderer.setAttribute(linkEl, 'target', '_blank'); // فقط خارجی
    }
  }
  

  /**
   * ناظر روی تغییرات DOM برای:  
   * - تغییر href  
   * - لینک‌هایی که CKEditor بعداً وارد DOM می‌کنه
   */
  private startObserver() {
    this.observer = new MutationObserver(() => {
      this.applyRelLogic();
    });

    this.observer.observe(this.el.nativeElement, {
      attributes: true,
      attributeFilter: ['href'],
      subtree: false
    });

    // ناظر روی والد‌ها برای زمانی که CKEditor لینک جدید وارد می‌کند
    let parent = this.el.nativeElement.parentElement;
    while (parent) {
      this.observer.observe(parent, {
        childList: true,
        subtree: true
      });
      parent = parent.parentElement;
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
